import { render, staticRenderFns } from "./SkillDetails.vue?vue&type=template&id=4b65bb9a&scoped=true&"
import script from "./SkillDetails.vue?vue&type=script&lang=js&"
export * from "./SkillDetails.vue?vue&type=script&lang=js&"
import style0 from "./SkillDetails.vue?vue&type=style&index=0&id=4b65bb9a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b65bb9a",
  null
  
)

export default component.exports